/** 语言类型 */
export enum LANG_TYPE {
  /** 简体中文 */
  ZH_CN = 'zh-CN',
  /** 英文 */
  EN_US = 'en-US',
  /** 繁体中文 */
  ZH_HK = 'zh-HK',
}

/** 存储语言偏好的 key */
export const LANG_STORAGE_KEY = 'oneid_web_lang';

/** 语言显示名称 */
export const LANG_LABELS: Record<string, string> = {
  [LANG_TYPE.ZH_CN]: '简体中文',
  [LANG_TYPE.EN_US]: 'English',
};
